import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { User } from '../../models/user';
import { storeByIMPSId } from '../../utils/converter';
import { getUsers } from '../../apis/user';

export interface State {
    allIds: string[];
    byId: Dictionary<User>;
    loading: Dictionary<boolean>;
}

export const users = createModel<State>({
    state: {
        allIds: ['system'],
        byId: {
            system: {
                impsId: 'system',
                lastName: 'Prominis'    // temp
            } as User
        },
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: MixType<User>,
            loadingKey?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...storeByIMPSId(data)
            };
            return {
                ...state,
                allIds: Object.keys(byId),
                byId: byId,
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getUsersAsync(
            _: Undefinable<{}>,
            rootState: RootState
        ) {
            if (
                !selectors.getLoading(rootState.users, 'getUsersAsync') &&
                selectors.getUserIds(rootState.users).length <= 1
            ) {
                this.loading('getUsersAsync', true);
                try {
                    const data = await getUsers();
                    this.update(data, 'getUsersAsync');
                } catch (e) {
                    window.console.log(e);
                    this.loading('getUsersAsync', false);
                }
            }
        }
    })
});
